import * as PIXI from "pixi.js";
import ModalPopAnimation from "../../../animation/ModalPopAnimation";
import addInteractivity from "../../../utils/addInteractivity"
import ModalRenderer from "./ModalRenderer";
import { CustomCursorType } from "../CustomCursor/CustomCursor";


export default class Modal {
  private ModalRenderer!: ModalRenderer;

  constructor(content: PIXI.Container, size: PIXI.Size, hideOverlay: boolean) {
    this.addModalRenderer(size, hideOverlay);
    this.ModalRenderer.wrapper.addChild(content);
  }
  private setModalWrapperScale = (v: number) => this.ModalRenderer.wrapper.scale.set(v);
  openModal() {
    const startVal = .4;
    const targetVal = 1;
    const onUpdate = (v: number) => this.setModalWrapperScale(v);
    this.ModalRenderer.visible = true;
    this.setModalWrapperScale(startVal);
    new ModalPopAnimation(startVal, targetVal, 200, onUpdate, () => { });
  }
  hideModal() {
    const startVal = 1;
    const targetVal = .4;
    const onUpdate = (v: number) => this.setModalWrapperScale(v);
    const onComp = () => this.ModalRenderer.visible = false;
    this.setModalWrapperScale(startVal);
    new ModalPopAnimation(startVal, targetVal, 150, onUpdate, onComp);
  }
  addModalRenderer(size: PIXI.Size, hideOverlay: boolean) {
    this.ModalRenderer = new ModalRenderer(null, size, hideOverlay);
    this.ModalRenderer.getDeactiveElms()
      .forEach(e => addInteractivity(e, {}, CustomCursorType.default));
  }
}